import { render, staticRenderFns } from "./Bugs.vue?vue&type=template&id=6ea76650&scoped=true&"
import script from "./Bugs.vue?vue&type=script&lang=js&"
export * from "./Bugs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea76650",
  null
  
)

component.options.__file = "Bugs.vue"
export default component.exports